import { ChatAction } from 'redux/db/util';
import ChoiceAction from '../../ChoiceAction';
import ConnectFigmaAction from '../../DsConversation/actions/ConnectFigmaAction';
import ConnectGithubAction from '../../DsConversation/actions/ConnectGithubAction';
import CreateDsAction from '../actions/CreateDsAction';
import ExportAiAction from '../actions/ExportAiAction';
import ExportAssetsAction from '../actions/ExportAssetsAction';
import ExportCodeAction from '../actions/ExportCodeAction';
import FollowUpAction from '../actions/FollowUpAction';
import OpenPrototypeAction from '../actions/OpenPrototypeAction';
import SceneNewChatAction from '../actions/SceneNewChatAction';

interface Props {
	action: ChatAction;
	isLastEntry?: boolean;
}

const SceneActionCard = ({ action, isLastEntry }: Props) => {
	switch (action.kind) {
		case 'export-frames-code':
			return (
				<ExportCodeAction
					label={action.label}
					framework={action.framework}
					frameworkInstructions={action.frameworkInstructions}
					frameIds={action.frameIds}
				/>
			);
		case 'export-frames-ai':
			return (
				<ExportAiAction
					label={action.label}
					preset={action.preset}
					customBrief={action.customBrief}
					frameIds={action.frameIds}
				/>
			);
		case 'export-frames-assets':
			return (
				<ExportAssetsAction
					label={action.label}
					format={action.format}
					frameIds={action.frameIds}
				/>
			);
		case 'choice':
			return <ChoiceAction options={action.options} chatType="scene" />;
		case 'open-prototype':
			return <OpenPrototypeAction label={action.label} frameId={action.frameId} />;
		case 'follow-up':
			if (!isLastEntry) return null;
			return <FollowUpAction label={action.label} prompt={action.prompt} />;
		case 'connect-figma':
			return <ConnectFigmaAction label={action.label} />;
		case 'connect-github':
			return <ConnectGithubAction label={action.label} />;
		case 'create-ds':
			return <CreateDsAction label={action.label} />;
		case 'new-chat':
			return <SceneNewChatAction />;
		default:
			return null;
	}
};

export default SceneActionCard;
